export const GET_EVENTS_REQUEST = "GET_EVENTS_REQUEST";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_FAILURE = "GET_EVENTS_FAILURE";

export const PUT_EVENTS_REQUEST = "PUT_EVENTS_REQUEST";
export const PUT_EVENTS_SUCCESS = "PUT_EVENTS_SUCCESS";
export const PUT_EVENTS_FAILURE = "PUT_EVENTS_FAILURE";

export const POST_EVENTS_REQUEST = "POST_EVENTS_REQUEST";
export const POST_EVENTS_SUCCESS = "POST_EVENTS_SUCCESS";
export const POST_EVENTS_FAILURE = "POST_EVENTS_FAILURE";
